import moment from "antd/node_modules/moment";
import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { FilterStore } from "../FilterStore";

export class UsersStore {
  loading = false;

  filterStore: FilterStore;

  filter: any = {
    page: 0,
    size: 20,
    status: "all",
    email: "",
    mobile: "",
    name: "",
    invitation: "",
    sexOffenderState: "",
    role: "",
    period: [undefined, undefined],
  };

  sortedInfo = { columnKey: "createDate", order: "descend" };

  data = {
    total: 0,
    items: [],
  };

  constructor() {
    makeAutoObservable(this, {
      pagination: computed,
    });
    this.filterStore = new FilterStore(this);
    this.filterStore.periodLabel = "Registration Time";
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    let period: string[] = [];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, period, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    console.log("query", params);
    const email = params.get("email") || "";
    const mobile = params.get("mobile") || "";
    const name = params.get("name") || "";
    const invitation = params.get("invitation") || "";
    const status = params.get("status") || "all";
    const sexOffenderState = params.get("sexOffenderState") || "";
    const role = params.get("role") || "";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "20");
    const periodStr = params.get("period") || ",";
    const period = periodStr !== "," ? periodStr.split(",").map((x) => moment(x)) : [undefined, undefined];
    console.log("p", period);
    this.filter = { name, email, mobile, invitation, status, period, page, size, sexOffenderState, role };
    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { period, status, page, size, email, mobile, name, invitation, sexOffenderState, role } = this.filter;

    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : undefined;

    const filter: any = {
      status,
      sexOffenderState,
      role,
      page,
      size,
      email,
      mobile,
      name,
      invitation,
      sorts,
    };
    if (period?.[0]) {
      filter.period = [moment(period[0]).startOf("day").toISOString(), moment(period[1]).endOf("day").toISOString()];
    }
    Api.user
      .users(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.users;
        });
      })
      .finally(() => (this.loading = false));
  }
}

export const usersStore = new UsersStore();
